<template>
    <div>
        <div
            v-if="$slots.wayToGet"
            class="form__split form__split-border"
        >
            <div class="form__split-title">
                <div class="h3 _mb-8">Способ получения</div>
            </div>
            <div class="form__split-fields">
                <slot name="wayToGet"></slot>
            </div>
        </div>
        <div class="form__split form__split-nopb">
            <div v-show="wayToGet === EWayToGet.DELIVERY" class="form__split-title">
                <div class="h3 _mb-8">Выберите место и время встречи</div>
                <slot name="rowDeliverySubtitle" />
            </div>

            <div v-show="wayToGet === EWayToGet.OFFICE" class="form__split-title">
                <div class="h3 _mb-8">Выберите удобный для вас офис</div>
            </div>

            <div class="form__split-fields">
                <div v-if="$slots.region" class="form__row">
                    <slot name="region"></slot>
                </div>
                <div v-if="$slots.city" class="form__row">
                    <slot name="city"></slot>
                </div>
                <div v-if="$slots.noCitiesDeliveryNotice" class="_mb-24">
                    <slot name="noCitiesDeliveryNotice"></slot>
                </div>
                <div v-if="$slots.noCitiesOfficeNotice" class="_mb-24">
                    <slot name="noCitiesOfficeNotice"></slot>
                </div>
                <div v-if="$slots.address" class="form__row">
                    <slot name="address"></slot>
                </div>
                <div v-if="$slots.office" class="form__row">
                    <slot name="office"></slot>
                </div>
                <div v-if="$slots.date" class="form__row">
                    <div class="form__col">
                        <slot name="date"></slot>
                    </div>
                    <div class="form__col">
                        <slot name="time"></slot>
                    </div>
                </div>
                <slot name="fieldsAppend"></slot>
            </div>
        </div>
    </div>
</template>
<script>
import { EWayToGet } from './const';

export default {
    name: 'DefaultLayout',
    data() {
        return {
            EWayToGet,
        };
    },
    props: {
        wayToGet: {
            type: String,
            required: true,
        },
    },
};
</script>
